import { Icon } from "@/components/Icon";
import { Input } from "@/components/Input";
import { SMSButton } from "@/components/SMSButton";
import { makePlatformOnClick } from "@/components/utils";
import { cn } from "@/libs";
import { Button } from "antd-mobile";
import { useEffect } from "react";
import styles from "./index.module.scss";
import { useSetup } from "./logic";

export const PageRegister = () => {
  const logic = useSetup();

  const announcement = (closeOnClick: () => void) => (
    <>
      <div className={cn(styles.announcementTitle)}>注册须知</div>
      <div className={cn(styles.announcementContent)}>
        <div className={cn(styles.announcementContentScroller)}>
          VipPay是一个专业的支付通道，基于C2C理念
          开发设计，全新的UI让会员耳目一新，全新的
          认证系统让真实的会员更有安全感，让骗单玩 家无处遁形，
          一旦发现骗单，平台将永久冻结账户，永不
          解封。最大程度的提升了会员与商户之间的
          用户粘度，构建商户与会员之间的紧密链接，
          VipPay将竭诚为广大客户提供最优质的服务。
          <br />
          交易过程中禁止添加好友 如果添加好友造成被骗单平台概不承担责任。
          <br />
          交易流程示范 注册-购买V币-到商户平台充值-提款下分
          V币-到我要卖币挂单等待买家购买-买家付
          款-卖家确认-完成交易。在这整个交易过程
          当中，还有一些注意事项，请您务必阅读。
          <br />
          第一： 为了保证会员之间的交易安全，平台采取的是
          实名制用户认证，并终身无法修改认证信息！
          会员必须遵守规定，严格启用本人身份信息，
          银行账号信息等；买家付款时必须使用本人身
          份信息的银行卡或者其支付工具来购买，如果
          使用他人银行账户代为付款，卖家有权可以不
          予确认收款。由于本人录入信息不符而造成的
          一切损失，由会员自行承担，平台不负担任何 责任；
          <br />
          第二： 为了保证卖家的信息安全，请买家务必在有需
          求的时候再进行订单确认，如若发生恶意刷
          单，锁定卖家额度而不付款的用户，平台将会 自动冻结账户；
          <br />
          第三： 在购买以及出售V币的交易时间，平台规定
          是必须在15分钟内完成，会员在购买或者出售
          的时候，一定要非常关注交易是否在正在进行
          当中，如有异议也及时的联系平台客服，申请
          人工客服介入！由于买卖双方长时间不确认的
          交易，系统将自动判定为成交或者取消，由于
          系统无法做到百分百准确，平台不承担任何责
          任。再次重申，请双方在交易的过程当中要时 刻注意订单变化！
          <br />
          第四： 『买家』在购买V币的时候，此单：一旦付款
          成功．请立即上传截图并点击『我己转账』确认，
          确认以后10分钟内如果还没有收到币，此单便
          为争议订单，请立即联系在线客服，否则系统将
          判断定您的付款无效，取消订单！
          <br />
          第五： 会员在出售V币的时候，此订单一旦挂单成
          功，如有『买家』下单购买并点击了『我已转
          账』请您马上查询是否收到汇款，如没有收到
          『买家』的转账，请立即点击『未收到转账』
          功能，并联系在线客服否则在10分钟后，系统
          会判断为此订单交易成功，系统将会自动打币 给『买家』；
        </div>
      </div>
      <Button
        fill="none"
        block
        shape="rounded"
        className={cn(styles.iReadAnnouncementButton)}
        onClick={closeOnClick}
      >
        我已阅读
      </Button>
    </>
  );

  const usernameInput = logic.isUserNameRegisterMode && (
    <Input
      className={cn(styles.input)}
      theme="auth"
      placeholder="请输入用户名"
      autocomplete="off"
      icon={<Icon className={cn(styles.icon)} name="username" size="24px" />}
      onChange={(e) => {
        logic.dispatch({
          type: "update_username",
          username: e.target.value,
        });
      }}
      value={logic.state.username}
    />
  );

  // 手机号输入框
  const phoneInput = logic.isPhoneNumberRegisterMode && (
    <Input
      className={cn(styles.input)}
      theme="auth"
      placeholder="请输入手机号"
      autocomplete="off"
      icon={<Icon className={cn(styles.icon)} name="phone" size="24px" />}
      onChange={(e) => {
        logic.dispatch({
          type: "update_phoneNumber",
          phoneNumber: e.target.value,
        });
      }}
      value={logic.state.phoneNumber}
    />
  );
  // 密码输入框
  const passwordInput = (
    <Input
      className={cn(styles.input)}
      theme="auth"
      type="password"
      placeholder="请输入密码"
      icon={<Icon className={cn(styles.icon)} name="pwd" size="24px" />}
      onChange={(e) => {
        logic.dispatch({
          type: "update_password",
          password: e.target.value,
        });
      }}
      value={logic.state.password}
    />
  );

  // 密码确认输入框
  const password2Input = (
    <Input
      className={cn(styles.input)}
      theme="auth"
      type="password"
      placeholder="请再次输入密码"
      icon={<Icon className={cn(styles.icon)} name="pwd" size="24px" />}
      onChange={(e) => {
        logic.dispatch({
          type: "update_confirmPassword",
          confirmPassword: e.target.value,
        });
      }}
      value={logic.state.confirmPassword}
    />
  );

  // 图片验证码
  const imageCodeInput = (
    <Input
      className={cn(styles.input)}
      theme="auth"
      placeholder="请输入验证码"
      icon={<Icon className={cn(styles.icon)} name="code" size="24px" />}
      extra={
        <img
          className={cn(styles.imageCode)}
          src={logic.state.verifyCode}
          alt="code"
          {...makePlatformOnClick((e) => {
            e.preventDefault();
            logic.flushCodeImage();
          })}
        />
      }
      onChange={(e) => {
        logic.dispatch({
          type: "update_imageCode",
          imageCode: e.target.value,
        });
      }}
      value={logic.state.imageCode}
    />
  );

  const dxCodeInput = (
    <div style={{
      display:'flex',
      justifyContent: 'center',
      width: '100%',
      marginBottom: '20px',
      position: 'relative',
      zIndex: 99,
    }}>
      <div id="dx_token" className={cn(styles.dx_token)}></div>
    </div>
  )

  // 短信验证码
  const smsCodeInput = logic.isPhoneNumberRegisterMode && (
    <Input
      className={cn(styles.input)}
      theme="auth"
      placeholder="请输入验证码"
      icon={<Icon className={cn(styles.icon)} name="code" size="24px" />}
      extra={<SMSButton sendSMS={logic.flushSMSCode} />}
      onChange={(e) => {
        logic.dispatch({
          type: "update_smsCode",
          smsCode: e.target.value,
        });
      }}
      value={logic.state.smsCode}
    />
  );

  useEffect(() => {
    const handler = logic.announce(
      cn(styles.announcementDialog),
      announcement(() => {
        handler.close();
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cn(styles.form)}>
      {usernameInput}
      {phoneInput}
      {logic.isSlideCodeType ? dxCodeInput : imageCodeInput}
      {smsCodeInput}
      {passwordInput}
      {password2Input}
      <Button
        fill="none"
        block
        shape="rounded"
        className={cn(styles.submitButton)}
        onClick={() => logic.submit()}
        loading={logic.loading}
      >
        注册
      </Button>
    </div>
  );
};
